import { mdiContentCopy } from '@mdi/js';
import Command from './_Command';
import { ApryseSDK } from '../../pdf/ApryseSDK';

export default class SessionCopyController extends Command {
    constructor() {
        super({
            Key: 'sessionCopyAnnotation',
            Enabled: ApryseSDK.canCopy,
            Path: mdiContentCopy,
            Callback: ApryseSDK.copyAnnotations,
        });
    }
}
